import client from "./client";

export interface Template {
  id: number;
  name: string;
  language: string | null;
  recipient: string | null;
  createdAt: string;
}

export interface Question {
  id: number;
  templateId: number;
  text: string;
  sortOrder: number;
}

export interface Chapter {
  id: number;
  name: string;
  /** Inclusive sort_order range of questions belonging to this chapter. */
  fromSort: number;
  toSort: number;
  /** Display order of the chapter within the template (0-based). */
  sortOrder: number;
}

export interface AvailableTemplate {
  recipient: string;
  language: string;
}

export const templatesApi = {
  getMy: () =>
    client.get<Template[]>("/templates/my"),

  getQuestions: (templateId: number) =>
    client.get<Question[]>(`/templates/${templateId}/questions`),

  getChapters: (templateId: number) =>
    client.get<Chapter[]>(`/templates/${templateId}/chapters`),

  getAvailable: () =>
    client.get<AvailableTemplate[]>("/templates/available"),

  assign: (recipient: string, language: string) =>
    client.post<{ templateId: number; name: string }>(
      "/templates/assign",
      { recipient, language },
    ),
};
